import { DateTime } from 'luxon'
import { License } from '@/models/license'

export function getSeasonEnd(
  license: Pick<License, 'bookingEndPeriod' | 'bookingTimeLimit'>,
  seasonStartYear: number
) {
  const hour = license.bookingTimeLimit
    ? `${license.bookingTimeLimit}:00`
    : `23:59:59`

  return DateTime.fromFormat(
    `${license.bookingEndPeriod}-${seasonStartYear} ${hour}`,
    'dd-LL-yyyy HH:mm:ss'
  ).toMillis()
}
